<template>
  <nav>
    <ul class="top-menu p0">
      <li>
        <router-link
          v-scroll-to="{ el: 'body', offset: -150 }"
          to="/"
          @click="closeMobileNav"
        >
          Home
        </router-link>
      </li>
      <li>
        <router-link
          to="/life-at-blibli"
          @click="closeMobileNav"
        >
          Life at Blibli
        </router-link>
      </li>
      <li>
        <router-link
          to="/jobs"
          @click="closeMobileNav"
        >
          Jobs
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script src="./js/top-menu.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';

ul.top-menu, .sticky ul.top-menu {
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 32px;

  li {
    a {
      color: $blu-color-neutral-text-med;
      &:hover {
        color: $blu-color-info-text-default;
      }
    }
    @include mobile {
      a {
        font: $blu-text-body-2;
        color: $blu-color-neutral-text-high;
        &:hover {
          color: $blu-color-neutral-text-med;
        }
      }
      &:hover {
        background-color: $blu-color-info-background-default;
        border-radius: $blu-border-radius-s;
      }
    }
  }

  @include mobile {
    padding: 16px 24px;
    flex-direction: column;
    gap: 8px;
  }
}

.header--open {
  .header__menu {
    background-color: $blu-color-neutral-background-low;
  }
  li {
    padding: 8px 4px;
  }
}
</style>
